/**
 * Map name for mutations
 * @types {string}
 */

export const SET_CATEGORIES = 'MAIN/FAQ/SET_CATEGORIES'
